export default __webpack_public_path__ + "static/media/greenArrow.3622a8e7.svg";